import { useAtom } from 'jotai';
import { userAtom } from '../store/atoms';

export const useAuth = () => {
  const [user] = useAtom(userAtom);

  // Auth durumu kontrolleri
  const isAuthenticated = !!user;
  const isGuest = user?.role === 'Guest';
  const isAnonymous = !user;

  // Yetki kontrolleri
  const canDelete = user && ['Admin', 'SuperAdmin', 'AccountOwner'].includes(user.role);
  const canCreate = user && ['Admin', 'SuperAdmin', 'AccountOwner', 'AgencyAccountViewer', 'BrandAccountViewer'].includes(user.role);
  const canComment = user && ['Admin', 'SuperAdmin', 'AccountOwner', 'AgencyAccountViewer', 'BrandAccountViewer', 'Guest'].includes(user.role);
  const canResolve = user && ['Admin', 'SuperAdmin', 'AccountOwner', 'BrandAccountViewer'].includes(user.role);
  const canShowAllComments = user && ['Admin', 'SuperAdmin', 'AccountOwner', 'AgencyAccountViewer', 'BrandAccountViewer'].includes(user.role);

  return {
    user,
    isAuthenticated,
    isGuest,
    isAnonymous,
    canDelete,
    canCreate,
    canComment,
    canResolve,
    canShowAllComments
  };
}; 